import { DEFAULT_LANGUAGE } from '../../configs/language'
import { localStorageKeys } from '../utils/common'

export const getLanguage = () => {
  return localStorage.getItem(localStorageKeys.KEY_LANGUAGE) || DEFAULT_LANGUAGE
}

export const saveLanguage = (lang) => {
  localStorage.setItem(localStorageKeys.KEY_LANGUAGE, lang)
}
